// extracted by mini-css-extract-plugin
export default {"row":"TableRowFlight_row__qk1YZ","deleteCell":"TableRowFlight_deleteCell__EUi9c","deleteButton":"TableRowFlight_deleteButton__VKw7C"};